<template>
    <ContentOrLoading>
        <div :class="['table', { 'expanded': bases.data.length <= 3 }]" v-if="bases && bases.data">
            <b-table 
                striped
                hover
                :fields="fields"
                :items="bases.data"
                :per-page="per_page"
            >
                <template #cell(opciones)="{ item, index }">
                    <OpcionesDropdownTableComponent 
                        :lastIndex="bases.data.length > 3 && index >= bases.data.length - 3"
                        v-bind:options="[
                            {
                                to: {
                                    name: 'back.bases.show',
                                    params: { lista_id: item.lista_id, base_id: item.id },
                                },
                                label: 'Ver deportista',
                            }
                        ]"
                    /> 
                </template>
            </b-table>
        </div>
        <div class="text-right" v-if="bases && bases.meta">
            <b-pagination
                v-model="bases.meta.current_page"
                :per-page="bases.meta.per_page"
            />
        </div>
    </ContentOrLoading>
</template>

<script>
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";

    export default {
        props: ['lista_id', 'user_id'],
        data() {
            return {
                bases: null,
                per_page: 10,
                current_page: 1,
                fields: [
                    { key: 'nombre', label: 'Nombre', class: 'text-center' },
                    { key: 'apellidos', label: 'Apellidos', class: 'text-center' },
                    { key: 'dni', label: 'DNI', class: 'text-center' },
                    { key: 'email', label: 'Email', class: 'text-center' },
                    { key: 'opciones', label: 'Opciones', class: 'text-center' }
                ]
            }
        },
        methods: {
            getBases() {
                this.loading = true;

                const params = {
                    filters: {
                        lista_id: this.lista_id,
                        per_page: this.per_page
                    },
                    user_id: this.user_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.usuarios.bases'), params).then(res => {
                    this.bases = res.data;
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        created() {
            this.getBases();
        },
        components: {
            OpcionesDropdownTableComponent
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>